import {
    Controller
} from "stimulus"
import retainScroll from '../retainScroll'

export default class extends Controller
{
    onClick
    retainScroll

    get shouldRetainScroll()
    {
        return this.data.get('retainScroll') === 'true'
    }

    connect()
    {
        this.onClick = this.handleClick.bind(this)
        if (this.shouldRetainScroll) {
            this.retainScroll = new retainScroll()
            this.element.addEventListener('click', this.onClick)
        }
    }

    handleClick(e)
    {
        e.preventDefault()
        this.retainScroll.visit(this.element.href)
    }

    stopListening()
    {
        this.element.removeEventListener('click', this.onClick)
        if (this.shouldRetainScroll) {
            this.retainScroll.tearDown()
            this.retainScroll = null
        }
    }

    disconnect()
    {
        this.stopListening()
    }
}


